import React, { useContext } from 'react'
import Button from '@hixme-ui/button'
import Text from '@hixme-ui/text'
import { LifeEventsContext } from 'routes/LifeEvents/LifeEventsContext'

export type AddBenefitButtonProps = {
  bundle: { BundlePublicKey: string; added: boolean }
  isProcessing?: boolean
  onRemoveFromCart: (bundlePublicKey: string, qleEnrollmentKey?: string) => void
  onAddToCart: (bundlePublicKey: string, qleEnrollmentKey?: string) => void
}

const AddBenefitButton = ({
  bundle: { BundlePublicKey, added },
  isProcessing,
  onRemoveFromCart,
  onAddToCart,
}: AddBenefitButtonProps) => {
  const qleCtx = useContext(LifeEventsContext)

  const onAddToCartHandler = () => {
    if (qleCtx) {
      const qleEnrollmentKey = qleCtx.state.shared.record?.qleResult[0]?.enrollmentPublicKey
      if (!qleEnrollmentKey) {
        throw new Error('QLE add to cart without QLE enrollment key')
      }
      onAddToCart(BundlePublicKey, qleEnrollmentKey)
    } else {
      onAddToCart(BundlePublicKey)
    }
  }

  const onRemoveFromCartHandler = () => {
    if (qleCtx) {
      const qleEnrollmentKey = qleCtx.state.shared.record?.qleResult[0]?.enrollmentPublicKey
      if (!qleEnrollmentKey) {
        throw new Error('QLE add to cart without QLE enrollment key')
      }
      onRemoveFromCart(BundlePublicKey, qleEnrollmentKey)
    } else {
      onRemoveFromCart(BundlePublicKey)
    }
  }

  return (
    <div style={{ width: '100%' }}>
      {added ? (
        <Button
          width="100%"
          submitting={isProcessing}
          submittingText="Removing from Benefits..."
          onClick={onRemoveFromCartHandler}
          style={{ backgroundColor: '#3A4951' }}
        >
          <Text fontWeight="600">Added to My Benefits</Text>
        </Button>
      ) : (
        <Button
          primary
          width="100%"
          submitting={isProcessing}
          submittingText="Adding to Benefits..."
          onClick={onAddToCartHandler}
        >
          <Text fontWeight="600">Add to My Benefits</Text>
        </Button>
      )}
    </div>
  )
}

export default AddBenefitButton
